export default "__VITE_ASSET__CbEMpHoc__"